import { render, staticRenderFns } from "./InfosProcessSection.vue?vue&type=template&id=bccaabb6"
import script from "./InfosProcessSection.vue?vue&type=script&lang=js"
export * from "./InfosProcessSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports